import React from 'react';

import DropDownList, { DropDownListOption } from '../UI/DropDownList';
import { WidgetPageComponentProps } from '../WidgetPage/WidgetWrapper';
import inputCss from '../UI/CustomInputField/CustomInputField.module.scss';

interface Props extends WidgetPageComponentProps {
  selected?: string;
  embedded?: boolean;
  onChange?: (value: string, label: string) => void;
  error?: boolean;
  options: DropDownListOption[];
}

const InclusivePronounSelection = (props: Props) => {
  const {
    changeAnswerValue,
    shouldEnable,
    onChange,
    embedded,
    widget,
    selected,
    error,
    options
  } = props;

  return (
    <div>
      <DropDownList
        placeholder="Choose Pronouns"
        options={options}
        onChange={(value, label) => {
          if (embedded && onChange) {
            onChange(value, label);
          } else {
            changeAnswerValue(widget, value);
            shouldEnable(widget, !!value);
          }
        }}
        data-e2e="inclusive-pronoun-select"
        initialSelection={selected}
        error={error}
      />

      {error && (
        <div className={inputCss.labelContainer}>
          <img
            className={inputCss.errorIcon}
            src="/static/error-icon.svg"
            alt="Input Error Icon"
          />
          <p className={inputCss.errorLabel} data-e2e="gender-label">
            Please make a selection
          </p>
        </div>
      )}
    </div>
  );
};

export default InclusivePronounSelection;
